import CustomVideoContainer from './containers/CustomVideoContainer'
import * as customVideoActions from './actions'
import CustomVideoSagas from './sagas'

export default CustomVideoContainer

export { customVideoActions, CustomVideoSagas }
